import "reflect-metadata";
import './lib/i18n.js';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { container } from "tsyringe";
import ContainerProvider from './tsyringe-hooks/ContainerProvider.tsx';
import { ud_di } from "./lib/di.ts";

import log from 'loglevel';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import timezone from 'dayjs/plugin/timezone';

import { IDomThemes, TOKEN_IDomThemes } from "./services/DomThemes.ts";
import { IWrapNavigation, TOKEN_IWrapNavigation } from "./services/WrapNavigation.ts";
import { IDomConnectivity, TOKEN_IDomConnectivity } from "./services/DomConnectivity.ts";
import { IDeviceCapabilities, TOKEN_IDeviceCapabilities } from "./services/DeviceCapabilities.ts";
import ScreenResizeStore from "./views/utility-stores/ScreenResizeStore.ts";
import { ITabFocusService, TOKEN_ITabFocusService } from "./services/TabFocusService.ts";
import { IBroadcastChannel, TOKEN_IBroadcastChannel } from "./services/BroadcastChannelService.ts";
import WrapPwa from "./WrapPwa.tsx";

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(isoWeek);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(timezone);

//Log levels for prod and debug
if (import.meta.env.PROD) {
  log.setLevel('error');
} else {
  log.setLevel('info');
}

ud_di(container);

container.resolve<IDomThemes>(TOKEN_IDomThemes);
container.resolve<IWrapNavigation>(TOKEN_IWrapNavigation);
container.resolve<IDomConnectivity>(TOKEN_IDomConnectivity);
container.resolve<IDeviceCapabilities>(TOKEN_IDeviceCapabilities);
container.resolve<ITabFocusService>(TOKEN_ITabFocusService);
container.resolve<IBroadcastChannel>(TOKEN_IBroadcastChannel);
container.resolve(ScreenResizeStore);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ContainerProvider container={container}>
      <WrapPwa />
    </ContainerProvider>
  </StrictMode>,
)
